import { j as l } from "../../../../jsx-runtime-B6kdoens.js";
import { forwardRef as o } from "react";
import { I as t } from "../../../../IconBase-CxZyIWw2.js";
const e = o(
  (i, s) => /* @__PURE__ */ l.jsx(
    t,
    {
      ref: s,
      ...i,
      image: (r) => /* @__PURE__ */ l.jsxs(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: 16,
          height: 16,
          fill: "none",
          viewBox: "0 0 16 16",
          ...r,
          children: [
            /* @__PURE__ */ l.jsx("g", { fill: "currentColor", clipPath: "url(#clip0_3410_69098)", children: /* @__PURE__ */ l.jsx("path", { d: "M9 0H7v3h2zM9 16v-3H7v3zM14.364 12.95l-1.414 1.414-2.121-2.121 1.414-1.415zM5.172 3.757 3.758 5.172 1.636 3.05l1.415-1.414zM14.364 3.05l-1.415-1.414-2.12 2.121 1.413 1.415zM5.171 12.243l-1.414-1.415-2.121 2.122 1.414 1.414zM16 9V7h-3v2zM3 9V7H0v2zM8 11a3 3 0 1 0 0-6 3 3 0 0 0 0 6" }) }),
            /* @__PURE__ */ l.jsx("defs", { children: /* @__PURE__ */ l.jsx("clipPath", { id: "clip0_3410_69098", children: /* @__PURE__ */ l.jsx("path", { fill: "#fff", d: "M0 0h16v16H0z" }) }) })
          ]
        }
      )
    }
  )
);
e.displayName = "SunIcon";
export {
  e as SunIcon,
  e as default
};
//# sourceMappingURL=index.js.map
